import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import { useMemo } from "react";
import Chart from "react-google-charts";
import { getPercentage } from "ultis/commonFunctions";

import datetimeHelper from "../../../helper/datetime-helper";
import DataNotFound from "./DataNotFound";
import classes from "./TableReportChat.module.css";

const TableReportChat = ({
  chatReport,
  onChangeExportRef,
  chartCriteria,
  listChartCriteria,
}) => {
  const chatReportChartData = useMemo(() => {
    if (!chatReport || chatReport?.length === 0) return null;

    let result = [
      [
        "Thời gian",
        "Số lượng cuộc chat",
        "Đã trả lời",
        "Miss",
        chartCriteria === listChartCriteria.responseRate.id
          ? listChartCriteria.responseRate.title
          : listChartCriteria.totalAgent.title,
      ],
    ];
    chatReport.forEach((item) => {
      result.push([
        item.date.split("-").slice(-2).reverse().join("-"),
        item.report?.done_thread + item.report?.missed_thread,
        item.report?.done_thread,
        item.report?.missed_thread,
        chartCriteria === listChartCriteria.responseRate.id
          ? getPercentage(
              item.report?.done_thread,
              item.report?.done_thread + item.report?.missed_thread
            ) || 0
          : item.report?.total_thread_agent || 0,
      ]);
    });
    return result;
  }, [chartCriteria, chatReport, listChartCriteria]);

  const COLUMNS = useMemo(
    () => [
      {
        id: "date",
        name: "Ngày",
        customValue: (row) => datetimeHelper.toFormat(row.date, "YYYY-MM-DD"),
      },
      {
        id: "total",
        name: "Tổng",
        customValue: (row) =>
          row.report?.done_thread + row.report?.missed_thread,
      },
      {
        id: "done_thread",
        name: "Trả lời",
        customValue: (row) => row.report?.done_thread,
      },
      {
        id: "missed_thread",
        name: "Nhỡ",
        customValue: (row) => row.report?.missed_thread,
      },
      {
        id: "response_rate",
        name: "Tỉ lệ trả lời",
        customValue: (row) =>
          `${
            getPercentage(
              row.report?.done_thread,
              row.report?.done_thread + row.report?.missed_thread
            ) || 0
          }%`,
      },
    ],
    []
  );

  const renderTableCellValue = (row, column) => {
    let value = column.customValue
      ? column.customValue(row, column)
      : row[column.id];
    return value;
  };

  const chatExportExcelData = useMemo(() => {
    return (
      chatReport?.map((item) =>
        COLUMNS.reduce((result, col) => {
          result[col.id] = col.customValue?.(item) ?? item[col.id];
          return result;
        }, {})
      ) || []
    );
  }, [COLUMNS, chatReport]);

  return (
    <>
      {chatReportChartData && (
        <Paper
          style={{ color: "black", padding: "16px", marginBottom: "16px" }}>
          <Grid container>
            <Grid xs={12}>
              <Chart
                width="100%"
                height="460px"
                chartType="ComboChart"
                data={chatReportChartData}
                options={{
                  title: "Báo cáo lưu lượng theo từng ngày",
                  seriesType: "bars",
                  legend: {
                    position: "bottom",
                  },
                  series: {
                    3: {
                      type: "line",
                      lineWidth: 4,
                      targetAxisIndex: 1,
                    },
                  },
                  colors: ["#4C73C7", "#E57C25", "#AFAFAF", "#F3C62F"],
                  vAxis: {
                    title: "Số lượng cuộc chat",
                    maxValue: 20,
                  },
                  hAxis: {
                    title: "Thời gian",
                  },
                  vAxes: {
                    1: {
                      title: "",
                      viewWindowMode: "explicit",
                      viewWindow: {
                        ...(chartCriteria ===
                          listChartCriteria.responseRate.id && { max: 100 }),
                        min: 0,
                      },
                    },
                  },
                }}
              />
            </Grid>
          </Grid>
        </Paper>
      )}
      {chatReport?.length > 0 && (
        <Paper style={{ color: "black", padding: 16 }}>
          <div className={classes.tableContainer}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  {COLUMNS.map((column, key) => (
                    <TableCell
                      key={key}
                      align={column.align}
                      style={{ width: column.width }}
                      className={classes.tableBodyCell}>
                      {column.name}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {chatReport?.map((row, columnIndex) => (
                  <TableRow key={columnIndex}>
                    {COLUMNS.map((column, cellIndex) => (
                      <TableCell
                        key={cellIndex}
                        align={column.align}
                        className={classes.tableBodyCell}
                        style={{ width: column.width }}>
                        {renderTableCellValue(row, column)}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
          <ExcelExport
            data={chatExportExcelData}
            fileName="Báo cáo chat.xlsx"
            ref={onChangeExportRef}>
            {COLUMNS.map((column, cellIndex) => (
              <ExcelExportColumn
                key={cellIndex}
                field={column.id}
                title={column.name}
                locked={true}
              />
            ))}
          </ExcelExport>
        </Paper>
      )}
      {chatReport?.length === 0 && (
        <Paper style={{ color: "black", padding: 16 }}>
          <DataNotFound />
        </Paper>
      )}
    </>
  );
};

export default TableReportChat;
